<nb-card class="card">
    <div class="container">

        <div class="innerContainer" style="margin-left: 1rem;">
            <div class="iconcontainer">
                <nb-icon icon="trash-2-outline" ></nb-icon>
            </div>
            <div>
                <h2>Borrar archivo</h2>
                <p>¿Está seguro de que desea eliminar el archivo <b>{{data.nombre}}</b>? <br>
                Esta acción no se puede revertir.</p>
            </div>
        </div>

        <nb-card *ngIf="showSpinner" class="container Spin1" style="background-color: transparent; border-color: transparent;">
            <app-spinner></app-spinner>  
        </nb-card> 

        <div class="innerContainer">
            <button class="btn btn-light" (click)="closeDialog()" style="border: 1px solid gray;">
                Cancelar
            </button>
            <button class="btn buttontz" (click)="eliminarArchivo()">
                Eliminar archivo
            </button>
        </div>

    </div>
</nb-card>
